import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  cleanBlankEntries({ formData }) {
    const entries = [...formData.entries()]

    for (const name of new Set(entries.map(([name]) => name))) formData.delete(name)
    for (const [name, value] of entries) {
      if (typeof value !== "string" || value.trim() !== "") formData.append(name, value)
    }
  }

  submit() {
    document.dispatchEvent(new CustomEvent("table-loading:show"))
  }
}
